/// <amd-module name="VSSUI/Components/Dynamic/index" />

export * from "./DynamicLink";
export { IDynamicLinkProps } from "./DynamicLink.Props";
export * from "./DynamicText";
export { IDynamicTextProps } from "./DynamicText.Props";
